// extracted by mini-css-extract-plugin
export var teamSection = "index-module--teamSection--6Tu21";
export var teamSectionContainer = "index-module--teamSectionContainer--WInRy";
export var teamSectionTitle = "index-module--teamSectionTitle--WSAeo";
export var teamSectionSubtitle = "index-module--teamSectionSubtitle--1Eqyz";
export var teammateItem = "index-module--teammate-item--e+VwU";
export var cardHeader = "index-module--cardHeader--Tr-x0";
export var cardText = "index-module--cardText--oFK6D";
export var cardImageWrap = "index-module--cardImageWrap--fPpY5";
export var cardImage = "index-module--cardImage--uhh8L";
export var container = "index-module--container--FL1a0";
export var leftContainer = "index-module--leftContainer--p1Iut";
export var cardContainer = "index-module--cardContainer--qbHG5";
export var flipped = "index-module--flipped--Ba4MH";
export var cardContainerBg = "index-module--cardContainerBg--qyDPq";
export var socialButtonsWrap = "index-module--socialButtonsWrap--gxB7C";
export var rightContainer = "index-module--rightContainer--scM4H";